import { useCallback, useState } from 'react';
import { logError } from '@betty/toolkit/logging';
import { DepositSettings } from '../state/deposit/deposit.types';
import DepositService from '../services/DepositService/DepositService';

const useDepositSettings = () => {
  const [data, setData] = useState<DepositSettings>();

  const fetch = useCallback(async (promoQualificationAmount?: number) => {
    try {
      setData(undefined);

      const data = await DepositService.getSettings({
        params: { promoQualificationAmount },
      });

      setData(data);

      return data;
    } catch (error) {
      logError('Deposit settings request failure.', error);
    }
  }, []);

  return { data, fetch };
};

export default useDepositSettings;
